import { get } from "lodash";

export const invoice = (state, invoiceId) =>
  get(state, ["orders", "invoices", "byInvoiceId", invoiceId], {});
